import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import * as Actions from "../../../../store/modules/resources";
import * as FActions from "../../../../store/modules/footer";
import {PropTypes} from "prop-types";
import {
	getNumberFormat,
	getObjectLength,
	getSelectFormat,
	objectToQueryString,
	pushUrl
} from "../../../../utils/functions";
import {BASE_PATH, RESOURCE_FACET_ADMIN_ORDER, RESOURCE_FACET_NAME, STATUS_NAME} from "../../../../wpconfig";
import SelectBox from "../../../etc/SelectBox";
import * as func from "../../../../utils/functions";

class ResourceFacet extends Component {
	constructor(props) {
		super(props);

		this.state = {
			url : 'wp-admin/admin.php?page=resource&',
			action : 'admin/resources'
		}
	}

	argsInputTextEvnet = (event) => {
		const {dataActions} = this.props;
		let param = this.props.param;
		param[event.target.name] = event.target.value;
		dataActions.setResources({"param": param});

		if (event.key === "Enter") {
			setTimeout(() => {
				this.search()
			}, 0);
		}
	}

	facetChangeEvent = (event) => {
		if (event.target.type === "checkbox") {
			let param = this.props.param;
			if (event.target.checked) {
				if (param[event.target.name].indexOf(event.target.value) < 0) {
					param[event.target.name].push(event.target.value);
				}
			} else {
				if (param[event.target.name].indexOf(event.target.value) > -1) {
					param[event.target.name].splice(param[event.target.name].indexOf(event.target.value), 1);
				}
			}
			const {dataActions} = this.props;
			dataActions.setResources({"param": param});

			setTimeout(() => {
				func.getData(this.state.action, this.props.param).then((response) => {
					response.checkedRecords = []
					this.props.dataActions.setResources(response);

					const url = objectToQueryString(this.props.param);
					pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
				});
			}, 0);
		} else if (event.target.type === "button") {
			let param = this.props.param;
			if (param[event.target.name].indexOf(event.target.value) < 0) {
				param[event.target.name].push(event.target.value);
			}
			const {dataActions} = this.props;
			dataActions.setResources({"param": param});

			setTimeout(() => {
				func.getData(this.state.action, this.props.param).then((response) => {
					this.props.dataActions.setResources(response);

					const url = objectToQueryString(this.props.param);
					pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
				});
			}, 0);
		} else {
			const {dataActions} = this.props;
			let param = this.props.param;
			param[event.target.name] = event.target.value;
			dataActions.setResources({"param": param});
		}
	}

	facetChangeEventOnly = (event) => {
		if (event.target.type === "checkbox") {
			let param = this.props.param;
			if (event.target.checked) {
				param[event.target.name] = event.target.value;
			} else {
				param[event.target.name] = '';
			}
			const {dataActions} = this.props;
			dataActions.setResources({"param": param});

			func.getData(this.state.action, param).then((response) => {
				response.checkedRecords = []
				this.props.dataActions.setResources(response);

				const url = objectToQueryString(param);
				pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
			});
		}
	}

	facetReset = (event) => {
		var param = this.props.param;
		Object.keys(this.props.param).map((key, i) => {
			if (!param[key] || param[key].length <= 0)
				return;
			if (key === 'records_per_page' || key === 'order' || key === 'orderby') {
			} else if (key === 'current_page') {
				param[key] = 1;
			} else if (Array.isArray(param[key])) {
				param[key] = [];
			} else {
				param[key] = "";
			}
		});

		const {dataActions} = this.props;
		dataActions.setResources({"param": param});
		func.getData(this.state.action, this.props.param).then((response) => {
			this.props.dataActions.setResources(response);

			pushUrl('검색', BASE_PATH + this.state.url, null);
		});
	}

	search = (event) => {
		func.getData(this.state.action, this.props.param).then((response) => {
			this.props.dataActions.setResources(response);

			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
		});
	}

	tabAction = (event) => {
		event.target.parentNode.classList.toggle('active');
	}

	morePopup = (type) => {
		this.props.fDataActions.setFooter({
			'isPopup1': this.props.isPopup1 === 'true' ? 'false' : 'true',
			'type': type,
			'part' : 'resources'
		});
	}

	setDate = (date) => {
		event.preventDefault();

		let s, e
		const d = new Date();
		d.setDate(d.getDate()+1)
		e = d
		let in_date_start, in_date_end
		// console.log(d)

		if (date === '1d') {
			s = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1)
		} else if (date === '1w') {
			s = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 7)
		} else if (date === '1m') {
			s = new Date(d.getFullYear(), d.getMonth() - 1, d.getDate())
		} else if (date === '1y') {
			s = new Date(d.getFullYear() - 1, d.getMonth(), d.getDate())
		}

		in_date_start = s.getFullYear() + '-' + ('0' + (s.getMonth() + 1)).slice(-2) + '-' + ('0' + (s.getDate())).slice(-2)
		in_date_end = e.getFullYear() + '-' + ('0' + (e.getMonth() + 1)).slice(-2) + '-' + ('0' + (e.getDate())).slice(-2)

		var param = this.props.param;
		param.in_date_start = in_date_start
		param.in_date_end = in_date_end
		this.props.dataActions.setResources({"param": param});

		func.getData(this.state.action, this.props.param).then((response) => {
			this.props.dataActions.setResources(response);

			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + this.state.url + url, null);
		});
	}

	render() {
		const facets = getObjectLength(this.props.facet) > 0 ? RESOURCE_FACET_ADMIN_ORDER : [];
		const param = this.props.param;
		
		return (
			<>
				<div className="d-flex justify-content-between align-items-center">
				<h6 className="con-title">패싯 검색</h6>
					<div className="d-flex">
						<button type="button" className="btn-search-ui ml-2" onClick={this.facetReset}>
							<span className="icon icon-size-24 icon-refresh-white" />
						</button>
					</div>
				</div>
				<div className="form-group mt-3">
					<label htmlFor="within_ks" className="form-label"><strong>결과내 검색</strong></label>
					<div className="input-group">
						<input type="text" name="sub_ks" value={param.sub_ks} onChange={this.argsInputTextEvnet}
						       className="form-control" autoComplete="off"/>
						<button className="btn btn-sm btn-primary" type="button" onClick={this.search}>검색</button>
					</div>
				</div>
				<div className="mt-3 pt-2 border-top">
					<label htmlFor="within_ks" className="form-label"><strong>날짜 검색</strong></label>
					<div className="form-row mb-1">
						<select className="form-control" name="date_type"
						        value={param.date_type} onChange={this.facetChangeEvent}>
							<option value="input_date">입력(생성)일</option>
							<option value="modified_date">최종수정일</option>
						</select>
					</div>
					<div className="form-row">
						<div className="col pl-0">
							<input type="text" name="in_date_start" value={param.in_date_start} 
										 onChange={this.argsInputTextEvnet}
							       className="form-control" autoComplete="off"/>
						</div>
						<div className="col-1">
							<span className="text-center align-middle">~</span>
						</div>
						<div className="col pr-0">
							<input type="text" name="in_date_end" value={param.in_date_end} onChange={this.argsInputTextEvnet}
							       className="form-control" autoComplete="off"/>
						</div>
					</div>
					<div className="form-row mt-1 d-flex">
						<div className="p-0 pt-1">
							<span className="badge badge-secondary mr-1 p-1" onClick={() => this.setDate('1d')}>1일</span>
							<span className="badge badge-secondary mr-1 p-1" onClick={() => this.setDate('1w')}>1주일</span>
							<span className="badge badge-secondary mr-1 p-1" onClick={() => this.setDate('1m')}>1달</span>
							<span className="badge badge-secondary p-1" onClick={() => this.setDate('1y')}>1년</span>
						</div>
						<a href="#" className="btn btn-outline-primary btn-sm ml-auto" onClick={this.search}>검색</a>
					</div>
				</div>
				<div className="mt-3 pt-2 border-top">
					<label htmlFor="within_ks" className="form-label"><strong>아이디 검증</strong></label>
					<div className="form-row mb-1">
						<div className="vertical-checkbox-list">
							<div className="checkbox-group">
								<div className="checkbox-group-cell">
									<div className="custom-control custom-checkbox">
										<input id="dbid_no_wos" name="dbid_no" type="checkbox" className="custom-control-input" value="wos"
										       checked={param.dbid_no == 'wos'}
										       onChange={this.facetChangeEventOnly}/>
										<label className="custom-control-label" htmlFor="dbid_no_wos">WoS ID 없는 논문</label>
									</div>
									<div className="custom-control custom-checkbox">
										<input id="dbid_no_scopus" name="dbid_no" type="checkbox" className="custom-control-input" value="scopus"
										       checked={param.dbid_no == 'scopus'}
										       onChange={this.facetChangeEventOnly}/>
										<label className="custom-control-label" htmlFor="dbid_no_scopus">Scopus ID 없는 논문</label>
									</div>
									<div className="custom-control custom-checkbox">
										<input id="dbid_no_kci" name="dbid_no" type="checkbox" className="custom-control-input" value="kci"
										       checked={param.dbid_no == 'kci'}
										       onChange={this.facetChangeEventOnly}/>
										<label className="custom-control-label" htmlFor="dbid_no_kci">KCI ID 없는 논문</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="mt-3 pt-2 border-top">
					<label htmlFor="within_ks" className="form-label"><strong>KRI검증</strong></label>
					<div className="form-row mb-1">
						<div className="vertical-checkbox-list">
							<div className="checkbox-group">
								<div className="checkbox-group-cell">
									<div className="custom-control custom-checkbox">
										<input id="kri_no_wos" name="kri_no" type="checkbox" className="custom-control-input" value="wos"
										       checked={param.kri_no == 'wos'}
										       onChange={this.facetChangeEventOnly}/>
										<label className="custom-control-label" htmlFor="kri_no_wos">KRI 검증 안된 WoS 논문</label>
									</div>
									<div className="custom-control custom-checkbox">
										<input id="kri_no_scopus" name="kri_no" type="checkbox" className="custom-control-input" value="scopus"
										       checked={param.kri_no == 'scopus'}
										       onChange={this.facetChangeEventOnly}/>
										<label className="custom-control-label" htmlFor="kri_no_scopus">KRI 검증 안된 Scopus 논문</label>
									</div>
									<div className="custom-control custom-checkbox">
										<input id="kri_no_kci" name="kri_no" type="checkbox" className="custom-control-input" value="kci"
										       checked={param.kri_no == 'kci'}
										       onChange={this.facetChangeEventOnly}/>
										<label className="custom-control-label" htmlFor="kri_no_kci">KRI 검증 안된 KCI 논문</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{this.props.facet && getObjectLength(this.props.facet) > 0 ?
					facets.map((fa, i) => {
						const facet = this.props.facet[fa];
						if (!facet)
							return;
						if(facet.result.length <= 0)
							return;
						if (fa === 'dept')
							facet.result = getSelectFormat(facet.result);
						return (
							<div key={i}>
								{(fa === 'dept') ?
									<div className="form-side-search">
										<div className="form-title">학과 선택</div>
										<SelectBox
											name={fa}
											title="선택해주세요"
											isMulti
											onAdd={this.facetChangeEvent}
											onRemove={this.facetChangeEvent}
											OptionData={facet.result}
										/>
									</div>
									:
									<div className="form-side-search mt-3">
										<div className="form-tree-item active" onClick={this.tabAction}>
											<button type="button" className="btn-tree-nav">{RESOURCE_FACET_NAME[fa]}</button>
											<div className="detail-tree-item mt-1">
												<div className="vertical-checkbox-list">
													<div className="checkbox-group">
														<div className="checkbox-group-cell">
															{facet.result.length > 0 && facet.result.map((item, index) => {
																if ((fa !== 'registered_db' && fa !== 'journal_ranking' && fa !== 'worker_name') && index >= 5)
																	return;

																if (!item.title)
																	return;

																const checked = this.props.param[fa].includes(item.title);

																item.value = fa === 'registered_db' ? item.title.toUpperCase() : item.title

																let title = fa === 'resource_status' ? STATUS_NAME[item.title] : item.title
																// title = fa === 'registered_db' ? title.toUpperCase() : title

																return (
																	<React.Fragment key={index}>
																		<div className="checkbox-group-cell" key={index}>
																			<div className="custom-control custom-checkbox">
																				{fa === 'worker_name' || fa === 'sendmail_co' || fa === 'sendmail_my' ?
																					<input id={fa + '_' + index} name={fa} type="checkbox"
																					       className="custom-control-input"
																					       checked={checked} onChange={this.facetChangeEventOnly}
																					       value={item.value}/>
																					:
																					<input id={fa + '_' + index} name={fa} type="checkbox"
																					       className="custom-control-input"
																					       checked={checked} onChange={this.facetChangeEvent} value={item.title}/>
																				}
																				<label className="custom-control-label"
																				       htmlFor={fa + '_' + index}>{title} ({getNumberFormat(item.count)})</label>
																			</div>
																		</div>
																	</React.Fragment>
																)
															})}
														</div>
													</div>
													{(fa !== 'registered_db' && facet.result.length > 5) &&
													<div className="checkbox-more">
														<button type="button" className="btn-checkbox-more" onClick={() => this.morePopup(fa)}>
															<span className="icon icon-size-24 icon-plus-black mr-2 align-top"/>More
														</button>
													</div>
													}
												</div>
											</div>
										</div>
									</div>
								}
							</div>
						)
					})
					: ''
				}
			</>
		)
	}
}

export default connect(
	(state) => ({
		totalRecords: state.resources.totalRecords ? state.resources.totalRecords : 0,
		facet: state.resources.facet ? state.resources.facet : {},
		param: state.resources.param ? state.resources.param : {},
		isPopup1: state.resources.isPopup1 ? state.resources.isPopup1 : false,
		// args: state.resources.args ? state.resources.args : {},
		// facet: state.resources.facet ? state.resources.facet : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(ResourceFacet)

ResourceFacet.propTypes = {
	args: PropTypes.object,
	facet: PropTypes.object,
};
